import Button from "@/components/Button";
import styles from "./SelectAllBar.module.scss";

interface SelectAllBarProps {
  allSelected: boolean;
  disabled: boolean;
  onToggleAll: () => void;
}

export default function SelectAllBar(props: SelectAllBarProps) {
  return (
    <div className={styles.selectAllBar}>
      <Button
        variant="link"
        onClick={props.onToggleAll}
        disabled={props.disabled}
        className={styles.selectAllButton}
      >
        {props.allSelected ? "Deselect" : "Select"} All
      </Button>
    </div>
  );
}
